import { log } from "../utils/logger";

export default function generateCampaigns({ SAMPLE_RECORD_COUNT = 200 } = {}) {
  log(`%c[+] Generating [${SAMPLE_RECORD_COUNT}] mock[DATA]`, "color:green");

  // Exported Array
  const SAMPLE_DATA = [];

  // Sample from SCE EONS Dashboard
  const SAMPLE_CUSTOMER_TYPES = [
    "BCD", // unknown
    "MBL", // unknown
    "RES", // Residential
    "UAC", // unknown
  ];

  const SAMPLE_PRIORITY_FLAG = [
    "Backup Generation",
    "Essential",
    "Essential-CallODM",
    "Essential-Major",
    "Essential-Major-BkpGen",
    "Essential-Major-CallODM",
    "Invalid Combination",
    "Major",
    "Major-BkpGen",
    "Major-CallODM",
    "MedBaseline",
    "MedBaseline-Critical",
    "MedBaseline-Critical-Red",
    "MedBaseline-RedList",
    "RedList",
  ];

  const SAMPLE_CITIES = {
    Irvine: "CA 11111",
    Albequerque: "NM 22222",
    "San Diego": "CA 33333",
    "Las Vegas": "NV 44444",
  };

  const SAMPLE_VOLTAGES = ["2", "4", "5", "7", "12", "14", "16", "25", "33"];

  function getSampleFromArray(array) {
    return array[Math.round(Math.random() * (array.length - 1))];
  }

  for (let i = 0; i < SAMPLE_RECORD_COUNT; i++) {
    const USE_CITY = getSampleFromArray(Object.keys(SAMPLE_CITIES));

    const sample_record = {
      pkid_bint: i,
      unique_id_vch: `unique${i}`, // guess
      account_vch: `acct123`,
      parent_account_vch: null,
      premise_vch: `premise`, //guess
      customer_type_vch: getSampleFromArray(SAMPLE_CUSTOMER_TYPES),
      language_vch: "english", // guess
      customer_name_vch: "Sample Corp",
      address1_vch: `${i} Main St`,
      address2_vch: i % 10 ? null : `Ste ${i}`,
      city_vch: USE_CITY,
      state_vch: SAMPLE_CITIES[USE_CITY].split(" ").pop(),
      zip_vch: SAMPLE_CITIES[USE_CITY].split(" ").shift(),
      county_vch: USE_CITY,
      priority_flag_vch: SAMPLE_PRIORITY_FLAG[i % SAMPLE_PRIORITY_FLAG.length],
      circuit_vch: USE_CITY,
      substation_vch: USE_CITY,
      district_vch: String(i % 20),
      voltage_vch: SAMPLE_VOLTAGES[i % SAMPLE_VOLTAGES.length],
      meterno_vch: "",
      device_vch: "",
      device_type: "",
      custom1_vch: "",
      custom2_vch: "",
      custom3_vch: "",
      custom4_vch: "",
      custom5_vch: "",
    };

    SAMPLE_DATA.push(sample_record);
  }

  return SAMPLE_DATA;
}
